var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      class: ["brief-detail-icon", _vm.iconClass],
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: _vm.pixelSize,
        height: _vm.pixelSize,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "aria-hidden": "true",
      },
    },
    [
      _vm.name === "chevron-left"
        ? _c("path", { attrs: { d: "m15 18-6-6 6-6" } })
        : _vm.name === "arrow-left"
        ? [
            _c("path", { attrs: { d: "m12 19-7-7 7-7" } }),
            _vm._v(" "),
            _c("path", { attrs: { d: "M19 12H5" } }),
          ]
        : _vm.name === "arrow-right"
        ? [
            _c("path", { attrs: { d: "M5 12h14" } }),
            _vm._v(" "),
            _c("path", { attrs: { d: "m12 5 7 7-7 7" } }),
          ]
        : _vm.name === "chevron-down"
        ? _c("path", { attrs: { d: "m6 9 6 6 6-6" } })
        : _vm.name === "chevron-up"
        ? _c("path", { attrs: { d: "m18 15-6-6-6 6" } })
        : _vm.name === "chevron-right"
        ? _c("path", { attrs: { d: "m9 18 6-6-6-6" } })
        : _vm.name === "chevrons-up-down"
        ? [
            _c("path", { attrs: { d: "m7 15 5 5 5-5" } }),
            _vm._v(" "),
            _c("path", { attrs: { d: "m7 9 5-5 5 5" } }),
          ]
        : _vm.name === "chevrons-down-up"
        ? [
            _c("path", { attrs: { d: "m7 20 5-5 5 5" } }),
            _vm._v(" "),
            _c("path", { attrs: { d: "m7 4 5 5 5-5" } }),
          ]
        : _vm.name === "search"
        ? [
            _c("circle", { attrs: { cx: "11", cy: "11", r: "8" } }),
            _vm._v(" "),
            _c("path", { attrs: { d: "m21 21-4.3-4.3" } }),
          ]
        : _vm.name === "folder"
        ? [
            _c("path", {
              attrs: {
                d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
              },
            }),
          ]
        : _vm.name === "folder-open"
        ? [
            _c("path", {
              attrs: {
                d: "m6 14 1.5-2.9A2 2 0 0 1 9.24 10H20a2 2 0 0 1 1.94 2.5l-1.54 6a2 2 0 0 1-1.95 1.5H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H18a2 2 0 0 1 2 2v2",
              },
            }),
          ]
        : _vm.name === "images"
        ? [
            _c("path", { attrs: { d: "M18 22H4a2 2 0 0 1-2-2V6" } }),
            _vm._v(" "),
            _c("path", {
              attrs: { d: "m22 13-1.296-1.296a2.41 2.41 0 0 0-3.408 0L11 18" },
            }),
            _vm._v(" "),
            _c("circle", { attrs: { cx: "12", cy: "8", r: "2" } }),
            _vm._v(" "),
            _c("rect", {
              attrs: { width: "16", height: "16", x: "6", y: "2", rx: "2" },
            }),
          ]
        : _vm.name === "refresh-cw"
        ? [
            _c("path", {
              attrs: {
                d: "M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8",
              },
            }),
            _vm._v(" "),
            _c("path", { attrs: { d: "M21 3v5h-5" } }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16",
              },
            }),
            _vm._v(" "),
            _c("path", { attrs: { d: "M8 16H3v5" } }),
          ]
        : _vm.name === "git-branch"
        ? [
            _c("line", { attrs: { x1: "6", x2: "6", y1: "3", y2: "15" } }),
            _vm._v(" "),
            _c("circle", { attrs: { cx: "18", cy: "6", r: "3" } }),
            _vm._v(" "),
            _c("circle", { attrs: { cx: "6", cy: "18", r: "3" } }),
            _vm._v(" "),
            _c("path", { attrs: { d: "M18 9a9 9 0 0 1-9 9" } }),
          ]
        : _vm.name === "share-2"
        ? [
            _c("circle", { attrs: { cx: "18", cy: "5", r: "3" } }),
            _vm._v(" "),
            _c("circle", { attrs: { cx: "6", cy: "12", r: "3" } }),
            _vm._v(" "),
            _c("circle", { attrs: { cx: "18", cy: "19", r: "3" } }),
            _vm._v(" "),
            _c("line", {
              attrs: { x1: "8.59", x2: "15.42", y1: "13.51", y2: "17.49" },
            }),
            _vm._v(" "),
            _c("line", {
              attrs: { x1: "15.41", x2: "8.59", y1: "6.51", y2: "10.49" },
            }),
          ]
        : _vm.name === "ellipsis-vertical"
        ? [
            _c("circle", { attrs: { cx: "12", cy: "12", r: "1" } }),
            _vm._v(" "),
            _c("circle", { attrs: { cx: "12", cy: "5", r: "1" } }),
            _vm._v(" "),
            _c("circle", { attrs: { cx: "12", cy: "19", r: "1" } }),
          ]
        : _vm.name === "grip-vertical"
        ? [
            _c("circle", { attrs: { cx: "9", cy: "12", r: "1" } }),
            _vm._v(" "),
            _c("circle", { attrs: { cx: "9", cy: "5", r: "1" } }),
            _vm._v(" "),
            _c("circle", { attrs: { cx: "9", cy: "19", r: "1" } }),
            _vm._v(" "),
            _c("circle", { attrs: { cx: "15", cy: "12", r: "1" } }),
            _vm._v(" "),
            _c("circle", { attrs: { cx: "15", cy: "5", r: "1" } }),
            _vm._v(" "),
            _c("circle", { attrs: { cx: "15", cy: "19", r: "1" } }),
          ]
        : _vm.name === "eye-off"
        ? [
            _c("path", {
              attrs: {
                d: "M10.733 5.076a10.744 10.744 0 0 1 11.205 6.575 1 1 0 0 1 0 .696 10.747 10.747 0 0 1-1.444 2.49",
              },
            }),
            _vm._v(" "),
            _c("path", {
              attrs: { d: "M14.084 14.158a3 3 0 0 1-4.242-4.242" },
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "M17.479 17.499a10.75 10.75 0 0 1-15.417-5.151 1 1 0 0 1 0-.696 10.75 10.75 0 0 1 4.446-5.143",
              },
            }),
            _vm._v(" "),
            _c("path", { attrs: { d: "m2 2 20 20" } }),
          ]
        : _vm.name === "eye"
        ? [
            _c("path", {
              attrs: {
                d: "M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0",
              },
            }),
            _vm._v(" "),
            _c("circle", { attrs: { cx: "12", cy: "12", r: "3" } }),
          ]
        : _vm.name === "plus"
        ? [
            _c("path", { attrs: { d: "M5 12h14" } }),
            _vm._v(" "),
            _c("path", { attrs: { d: "M12 5v14" } }),
          ]
        : _vm.name === "sparkles"
        ? [
            _c("path", {
              attrs: {
                d: "M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z",
              },
            }),
            _vm._v(" "),
            _c("path", { attrs: { d: "M20 3v4" } }),
            _vm._v(" "),
            _c("path", { attrs: { d: "M22 5h-4" } }),
            _vm._v(" "),
            _c("path", { attrs: { d: "M4 17v2" } }),
            _vm._v(" "),
            _c("path", { attrs: { d: "M5 18H3" } }),
          ]
        : _vm.name === "panel-right-close"
        ? [
            _c("rect", {
              attrs: { width: "18", height: "18", x: "3", y: "3", rx: "2" },
            }),
            _vm._v(" "),
            _c("path", { attrs: { d: "M15 3v18" } }),
            _vm._v(" "),
            _c("path", { attrs: { d: "m8 9 3 3-3 3" } }),
          ]
        : _vm.name === "paperclip"
        ? _c("path", {
            attrs: {
              d: "m21.44 11.05-9.19 9.19a6 6 0 0 1-8.49-8.49l8.57-8.57A4 4 0 1 1 18 8.84l-8.59 8.57a2 2 0 0 1-2.83-2.83l8.49-8.48",
            },
          })
        : _vm.name === "tag"
        ? [
            _c("path", {
              attrs: {
                d: "M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z",
              },
            }),
            _vm._v(" "),
            _c("circle", {
              attrs: { cx: "7.5", cy: "7.5", r: ".5", fill: "currentColor" },
            }),
          ]
        : _vm.name === "image"
        ? [
            _c("rect", {
              attrs: {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2",
                ry: "2",
              },
            }),
            _vm._v(" "),
            _c("circle", { attrs: { cx: "9", cy: "9", r: "2" } }),
            _vm._v(" "),
            _c("path", {
              attrs: { d: "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21" },
            }),
          ]
        : _vm.name === "link"
        ? [
            _c("path", {
              attrs: {
                d: "M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71",
              },
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71",
              },
            }),
          ]
        : _vm.name === "send"
        ? [
            _c("path", {
              attrs: {
                d: "M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z",
              },
            }),
            _vm._v(" "),
            _c("path", { attrs: { d: "m21.854 2.147-10.94 10.939" } }),
          ]
        : _vm.name === "pencil"
        ? [
            _c("path", {
              attrs: { d: "M17 3a2.85 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5Z" },
            }),
            _vm._v(" "),
            _c("path", { attrs: { d: "m15 5 4 4" } }),
          ]
        : _vm.name === "file-text"
        ? [
            _c("path", {
              attrs: {
                d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z",
              },
            }),
            _vm._v(" "),
            _c("path", { attrs: { d: "M14 2v4a2 2 0 0 0 2 2h4" } }),
            _vm._v(" "),
            _c("path", { attrs: { d: "M10 9H8" } }),
            _vm._v(" "),
            _c("path", { attrs: { d: "M16 13H8" } }),
            _vm._v(" "),
            _c("path", { attrs: { d: "M16 17H8" } }),
          ]
        : _vm.name === "message-square"
        ? [
            _c("path", {
              attrs: {
                d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z",
              },
            }),
          ]
        : _vm.name === "rotate-ccw"
        ? [
            _c("path", {
              attrs: { d: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" },
            }),
            _vm._v(" "),
            _c("path", { attrs: { d: "M3 3v5h5" } }),
          ]
        : _vm.name === "library"
        ? [
            _c("path", { attrs: { d: "m16 6 4 14" } }),
            _vm._v(" "),
            _c("path", { attrs: { d: "M12 6v14" } }),
            _vm._v(" "),
            _c("path", { attrs: { d: "M8 8v12" } }),
            _vm._v(" "),
            _c("path", { attrs: { d: "M4 4v16" } }),
          ]
        : _vm.name === "check"
        ? [_c("path", { attrs: { d: "m20 6-11 11-5-5" } })]
        : _vm.name === "x"
        ? [
            _c("path", { attrs: { d: "M18 6 6 18" } }),
            _vm._v(" "),
            _c("path", { attrs: { d: "m6 6 12 12" } }),
          ]
        : _vm.name === "save"
        ? [
            _c("path", {
              attrs: {
                d: "M15.2 3a2 2 0 0 1 1.4.6l3.8 3.8a2 2 0 0 1 .6 1.4V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z",
              },
            }),
            _vm._v(" "),
            _c("path", {
              attrs: { d: "M17 21v-7a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v7" },
            }),
            _vm._v(" "),
            _c("path", { attrs: { d: "M7 3v4a1 1 0 0 0 1 1h7" } }),
          ]
        : _vm.name === "download"
        ? [
            _c("path", {
              attrs: { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" },
            }),
            _vm._v(" "),
            _c("polyline", { attrs: { points: "7 10 12 15 17 10" } }),
            _vm._v(" "),
            _c("line", { attrs: { x1: "12", x2: "12", y1: "15", y2: "3" } }),
          ]
        : _vm.name === "mail"
        ? [
            _c("rect", {
              attrs: { width: "20", height: "16", x: "2", y: "4", rx: "2" },
            }),
            _vm._v(" "),
            _c("path", {
              attrs: { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" },
            }),
          ]
        : _vm.name === "megaphone"
        ? [
            _c("path", { attrs: { d: "m3 11 18-5v12L3 14v-3z" } }),
            _vm._v(" "),
            _c("path", { attrs: { d: "M11.6 16.8a3 3 0 1 1-5.8-1.6" } }),
          ]
        : _vm.name === "presentation"
        ? [
            _c("path", { attrs: { d: "M2 3h20" } }),
            _vm._v(" "),
            _c("path", {
              attrs: { d: "M21 3v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V3" },
            }),
            _vm._v(" "),
            _c("path", { attrs: { d: "m7 21 5-5 5 5" } }),
          ]
        : _vm.name === "activity"
        ? [
            _c("path", {
              attrs: {
                d: "M22 12h-2.48a2 2 0 0 0-1.93 1.46l-2.35 8.36a.25.25 0 0 1-.48 0L9.24 2.18a.25.25 0 0 0-.48 0l-2.35 8.36A2 2 0 0 1 4.49 12H2",
              },
            }),
          ]
        : _vm.name === "book-marked"
        ? [
            _c("path", { attrs: { d: "M10 2v8l3-3 3 3V2" } }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
              },
            }),
          ]
        : _vm.name === "user"
        ? [
            _c("path", {
              attrs: { d: "M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" },
            }),
            _vm._v(" "),
            _c("circle", { attrs: { cx: "12", cy: "7", r: "4" } }),
          ]
        : _vm.name === "user-plus"
        ? [
            _c("path", {
              attrs: { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" },
            }),
            _vm._v(" "),
            _c("circle", { attrs: { cx: "9", cy: "7", r: "4" } }),
            _vm._v(" "),
            _c("line", { attrs: { x1: "19", x2: "19", y1: "8", y2: "14" } }),
            _vm._v(" "),
            _c("line", { attrs: { x1: "22", x2: "16", y1: "11", y2: "11" } }),
          ]
        : _vm.name === "users"
        ? [
            _c("path", {
              attrs: { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" },
            }),
            _vm._v(" "),
            _c("circle", { attrs: { cx: "9", cy: "7", r: "4" } }),
            _vm._v(" "),
            _c("path", { attrs: { d: "M22 21v-2a4 4 0 0 0-3-3.87" } }),
            _vm._v(" "),
            _c("path", { attrs: { d: "M16 3.13a4 4 0 0 1 0 7.75" } }),
          ]
        : _vm.name === "calendar"
        ? [
            _c("path", { attrs: { d: "M8 2v4" } }),
            _vm._v(" "),
            _c("path", { attrs: { d: "M16 2v4" } }),
            _vm._v(" "),
            _c("rect", {
              attrs: { width: "18", height: "18", x: "3", y: "4", rx: "2" },
            }),
            _vm._v(" "),
            _c("path", { attrs: { d: "M3 10h18" } }),
          ]
        : _vm.name === "calendar-clock"
        ? [
            _c("path", {
              attrs: {
                d: "M21 7.5V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h3.5",
              },
            }),
            _vm._v(" "),
            _c("path", { attrs: { d: "M16 2v4" } }),
            _vm._v(" "),
            _c("path", { attrs: { d: "M8 2v4" } }),
            _vm._v(" "),
            _c("path", { attrs: { d: "M3 10h5" } }),
            _vm._v(" "),
            _c("path", { attrs: { d: "M17.5 17.5 16 16.3V14" } }),
            _vm._v(" "),
            _c("circle", { attrs: { cx: "16", cy: "16", r: "6" } }),
          ]
        : _vm.name === "upload"
        ? [
            _c("path", {
              attrs: { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" },
            }),
            _vm._v(" "),
            _c("polyline", { attrs: { points: "17 8 12 3 7 8" } }),
            _vm._v(" "),
            _c("line", { attrs: { x1: "12", x2: "12", y1: "3", y2: "15" } }),
          ]
        : _vm.name === "briefcase"
        ? [
            _c("path", {
              attrs: { d: "M16 20V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" },
            }),
            _vm._v(" "),
            _c("rect", {
              attrs: { width: "20", height: "14", x: "2", y: "6", rx: "2" },
            }),
          ]
        : _vm.name === "external-link"
        ? [
            _c("path", { attrs: { d: "M15 3h6v6" } }),
            _vm._v(" "),
            _c("path", { attrs: { d: "M10 14 21 3" } }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6",
              },
            }),
          ]
        : _vm.name === "layers"
        ? [
            _c("path", {
              attrs: {
                d: "m12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83Z",
              },
            }),
            _vm._v(" "),
            _c("path", {
              attrs: { d: "m22 17.65-9.17 4.16a2 2 0 0 1-1.66 0L2 17.65" },
            }),
            _vm._v(" "),
            _c("path", {
              attrs: { d: "m22 12.65-9.17 4.16a2 2 0 0 1-1.66 0L2 12.65" },
            }),
          ]
        : _vm.name === "file-check2"
        ? [
            _c("path", {
              attrs: { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4" },
            }),
            _vm._v(" "),
            _c("path", { attrs: { d: "M14 2v4a2 2 0 0 0 2 2h4" } }),
            _vm._v(" "),
            _c("path", { attrs: { d: "m3 15 2 2 4-4" } }),
          ]
        : _vm.name === "trash2"
        ? [
            _c("path", { attrs: { d: "M3 6h18" } }),
            _vm._v(" "),
            _c("path", {
              attrs: { d: "M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6" },
            }),
            _vm._v(" "),
            _c("path", { attrs: { d: "M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2" } }),
            _vm._v(" "),
            _c("line", { attrs: { x1: "10", x2: "10", y1: "11", y2: "17" } }),
            _vm._v(" "),
            _c("line", { attrs: { x1: "14", x2: "14", y1: "11", y2: "17" } }),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }